import { Box } from "@mui/material";
import { SectionAccordion } from "@/pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/note-forms/readmission-f2f";
import Text from "@/components/Text";
import MiniCogClockUpload from "./MiniCogClockUpload";
import MiniCogRecallFields from "./MiniCogRecallFields";
import MiniCogScoring from "./MiniCogScoring";
import MiniCogStepHeading from "./MiniCogStepHeading";
import MiniCogWordVersions from "./MiniCogWordVersions";
import { MINI_COG_TEXT } from "../initial-f2f-mini-cog-constant";
import { computeMiniCogTotal } from "../initial-f2f-mini-cog-utils";
import { MiniCogValue } from "../initial-f2f-types";

export interface MiniCogSectionProps {
  title: string;
  expanded: boolean;
  onToggle: () => void;
  value: MiniCogValue;
  onChange: (value: MiniCogValue) => void;
  appointmentId?: string;
  clockDrawingUrl?: string;
}

const MiniCogSection = ({
  title,
  expanded,
  onToggle,
  value,
  onChange,
  appointmentId,
  clockDrawingUrl,
}: MiniCogSectionProps) => {
  const patch = (changes: Partial<MiniCogValue>) =>
    onChange({ ...value, ...changes });

  return (
    <SectionAccordion
      title={title}
      expanded={expanded}
      onToggle={onToggle}
      showCurrentVisit={false}
      unmountWhenCollapsed
    >
      <Box display="flex" flexDirection="column" gap={1.5}>
        <MiniCogStepHeading>{MINI_COG_TEXT.step1Title}</MiniCogStepHeading>
        <Text size={13}>{MINI_COG_TEXT.step1Instruction}</Text>
        <Text size={13}>
          {MINI_COG_TEXT.step1Note}
          <sup>{MINI_COG_TEXT.step1NoteSuperscript}</sup>
          {MINI_COG_TEXT.step1NoteTail}
        </Text>
        <MiniCogWordVersions
          selected={value.registrationWords}
          onChange={(registrationWords) => patch({ registrationWords })}
        />

        <MiniCogStepHeading>{MINI_COG_TEXT.step2Title}</MiniCogStepHeading>
        <Text size={13}>{MINI_COG_TEXT.step2Instruction}</Text>
        <MiniCogClockUpload
          image={value.clockImage}
          onChange={(clockImage) => patch({ clockImage })}
          appointmentId={appointmentId}
          savedImageUrl={clockDrawingUrl}
        />

        <MiniCogStepHeading>{MINI_COG_TEXT.step3Title}</MiniCogStepHeading>
        <Text size={13}>{MINI_COG_TEXT.step3Instruction}</Text>
        <MiniCogRecallFields
          wordListVersion={value.wordListVersion}
          personsAnswers={value.personsAnswers}
          onVersionChange={(wordListVersion) => patch({ wordListVersion })}
          onAnswersChange={(personsAnswers) => patch({ personsAnswers })}
        />

        <MiniCogScoring
          wordRecallScore={value.wordRecallScore}
          clockDrawScore={value.clockDrawScore}
          total={computeMiniCogTotal(value)}
          onWordRecallChange={(wordRecallScore) => patch({ wordRecallScore })}
          onClockDrawChange={(clockDrawScore) => patch({ clockDrawScore })}
        />
      </Box>
    </SectionAccordion>
  );
};

export default MiniCogSection;
